export default __webpack_public_path__ + "static/media/fiber-cement-boards.29e6de6f.svg";